module.exports = __webpack_public_path__ + "img/EALogo2.d26f4281.svg";